"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignProp = void 0;
const alignValues = ['left', 'center', 'right'];
const alignProp = {
    type: 'enum',
    className: 'rt-r-ta',
    values: alignValues,
    default: undefined,
    responsive: true,
};
exports.alignProp = alignProp;
//# sourceMappingURL=text-align.prop.js.map